// ASK-163 Client 4s item 1b — the toast: it dismisses itself, it carries a close, and a later toast is never
// hidden early by an earlier one's timer.
//
// Vanessa, BETA001b (prod, phone): "Sent — thank you. The shop's team will see it." never left the screen.
// Measured on dev 9776c75 (probe-phone-walk P9g/P9h): `app._toast` auto-hid only when the caller passed
// `autohideMs`; the Report's caller did not, and the toast had no close. The console's toasts (§6,
// `--gg-toast-duration`, 4 s) are the grammar: a plain notice dwells the token's time and goes; a toast that
// carries a repair ACTION ("Shop updated · Refresh") waits for the person — Material's snackbar rule — but
// every toast can be closed by its ✕.
import { icon } from "./_icons.js";

export const TOAST_DEFAULT_MS = 4000;

/** How long a toast stays: explicit dwell → that; an action → null (waits for the person); else the token. */
export function toastDwellMs({ actionLabel, autohideMs } = {}, tokenMs = TOAST_DEFAULT_MS) {
	if (Number.isFinite(autohideMs) && autohideMs > 0) return autohideMs;
	if (actionLabel) return null;
	return Number.isFinite(tokenMs) && tokenMs > 0 ? tokenMs : TOAST_DEFAULT_MS;
}

let _timer = null;

/** Draw (or redraw) the single toast. Never blocks; non-critical. */
export function showToast(msg, { actionLabel, onAction, autohideMs } = {}) {
	try {
		if (typeof document === "undefined") return;
		let host = document.getElementById("kapowx-toast");
		if (!host) {
			host = document.createElement("div");
			host.id = "kapowx-toast";
			host.className = "kapowx-toast";
			host.setAttribute("role", "status");
			// The toast has a control (its ✕), so HUD chrome over it steps aside like over any sheet (_hud-safe-zone.js) —
			// measured: the Studio's catalogue notice (z 2147483000, top 64 px) took the ✕'s tap in merchant landscape.
			host.setAttribute("data-sheet", "");
			// …and it is HUD to a modal sheet (Material: a dialog out-ranks a snackbar): over the Report or the cart it
			// steps aside rather than cover their controls (measured: the ✕ over the Report's "Include the picture").
			host.setAttribute("data-hud", "");
			document.body.appendChild(host);
		}
		host.innerHTML = `<span class="kapowx-toast__text"></span>${actionLabel ? `<button type="button" class="kapowx-toast__action"></button>` : ""}<button type="button" class="kapowx-toast__close" data-toast-close aria-label="Dismiss">${icon("close")}</button>`;
		host.querySelector(".kapowx-toast__text").textContent = String(msg);
		if (actionLabel) host.querySelector(".kapowx-toast__action").textContent = String(actionLabel);
		clearTimeout(_timer);
		_timer = null;
		requestAnimationFrame(() => { host.classList.add("is-visible"); });
		const hide = () => { clearTimeout(_timer); _timer = null; host.classList.remove("is-visible"); };
		if (actionLabel && onAction) host.querySelector(".kapowx-toast__action")?.addEventListener("click", () => { hide(); onAction(); });
		host.querySelector("[data-toast-close]").addEventListener("click", hide);
		const token = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--gg-toast-duration"), 10);
		const dwell = toastDwellMs({ actionLabel, autohideMs }, token);
		if (dwell) _timer = setTimeout(hide, dwell);
	} catch { /* toast is non-critical */ }
}
